<script lang="ts">
	import { dev } from '$app/environment';
	import Icon from '$lib/components/icons/Icon.svelte';

	interface Props {
		question: string;
		answerHtml: string;
		noBottomBorder?: boolean;
		isExpanded?: boolean;
		onExpand?: (isExpanded: boolean) => void;
	}

	const {
		question,
		answerHtml,
		noBottomBorder = false,
		isExpanded = false,
		onExpand,
	}: Props = $props();

	// only in development, automatically removed in production builds
	if (dev) {
		const tagnames = [
			...new Set([...answerHtml.matchAll(/<([^ />]*)/g)].map(x => x[1].trim()).filter(Boolean)),
		];
		const allowedTagnames = ['p', 'a', 'strong', 'em', 'ul', 'li', 'br'];
		const invalidTags = tagnames.filter(t => !allowedTagnames.includes(t));
		if (invalidTags.length) {
			throw new Error(
				`FAQ question "${question}" answerHtml "${answerHtml.slice(0, 20)}..." contains invalid tags: ${invalidTags.join(', ')}`,
			);
		}
	}
</script>

<div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
	<h2 itemprop="name" class="m-0">
		<button
			onclick={() => onExpand?.(!isExpanded)}
			class="text-coloredneutral-soft text-sm bg-transparent border-0 p-0 flex items-center w-full justify-between"
		>
			<span class="text-left text-bold my-2 overflow-hidden">{question}</span>
			<Icon icon={isExpanded ? 'remove' : 'add'} class="flex-shrink-0 text-md" tag="span" />
		</button>
	</h2>
	<div
		itemscope
		itemprop="acceptedAnswer"
		itemtype="https://schema.org/Answer"
		class="answer overflow-hidden {isExpanded ? '' : 'h-0'} {noBottomBorder
			? ''
			: 'border-b-1 border-b-solid border-coloredneutral-weak'}"
	>
		<div itemprop="text" class="answer-html text-coloredneutral text-sm">
			<!-- eslint-disable-next-line svelte/no-at-html-tags -->
			{@html answerHtml}
		</div>
	</div>
</div>

<style>
	.answer :global(a) {
		/* inline link styles for FAQ here*/
		color: currentColor;
	}
	.answer-html :global(> p:first-child) {
		margin-top: 0;
	}
</style>
